<div class="flex flex-col gap-4">
    <div class="flex flex-col gap-2">
        <p class="m-0 text-sm font-semibold text-primary">Start monitoring from</p>
        <div class="flex flex-wrap gap-2" role="group" aria-label="Start monitoring from">
            @for (preset of startPresets; track preset.id) {
            <button type="button" (click)="selectStart(preset.id)" [class]="chipClass(selectedStart() === preset.id)"
                [attr.aria-pressed]="selectedStart() === preset.id">{{ preset.label }}</button>
            }
        </div>
    </div>

    <div class="flex flex-col gap-2">
        <p class="m-0 text-sm font-semibold text-primary">Keep watching for</p>
        <div class="flex flex-wrap gap-2" role="group" aria-label="Keep watching for">
            @for (preset of durationPresets; track preset.id) {
            <button type="button" (click)="selectDuration(preset.id)"
                [class]="chipClass(selectedDuration() === preset.id)"
                [attr.aria-pressed]="selectedDuration() === preset.id">{{ preset.label }}</button>
            }
            <button type="button" (click)="chooseCustom()" [class]="chipClass(selectedDuration() === 'custom')"
                [attr.aria-pressed]="selectedDuration() === 'custom'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-4" aria-hidden="true">
                    <path d="M8 2v4" />
                    <path d="M16 2v4" />
                    <rect width="18" height="18" x="3" y="4" rx="2" />
                    <path d="M3 10h18" />
                </svg>
                Custom dates
            </button>
        </div>
    </div>

    @if (selectedDuration() === 'custom') {
    <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <label class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wide text-secondary">Start</span>
            <input type="date" aria-label="Custom monitoring start" [attr.min]="earliestInput()"
                [attr.max]="todayInput()" [value]="startInput()" (input)="onCustomStart($event)"
                class="block w-full rounded-md border border-border bg-input px-3 py-2 text-sm text-foreground disabled:opacity-50" />
        </label>
        <label class="flex flex-col gap-1">
            <span class="text-xs font-semibold uppercase tracking-wide text-secondary">End</span>
            <input type="date" aria-label="Custom monitoring end" [attr.min]="endMinInput()" [attr.max]="endMaxInput()"
                [value]="endInput()" [disabled]="!startInput()" (input)="onCustomEnd($event)"
                class="block w-full rounded-md border border-border bg-input px-3 py-2 text-sm text-foreground disabled:opacity-50" />
        </label>
    </div>
    }

    <div class="flex items-center justify-between gap-3 rounded-xl bg-muted px-4 py-3">
        <div class="flex min-w-0 items-center gap-4">
            <div>
                <p class="m-0 text-xs font-semibold uppercase tracking-wide text-secondary">From</p>
                <p class="m-0 text-base font-bold text-primary">{{ fromLabel() }}</p>
            </div>
            <span class="text-secondary" aria-hidden="true">→</span>
            <div>
                <p class="m-0 text-xs font-semibold uppercase tracking-wide text-secondary">To</p>
                <p class="m-0 text-base font-bold text-primary">{{ toLabel() }}</p>
            </div>
        </div>
        @if (dayCount(); as days) {
        <span class="shrink-0 rounded-full bg-brand-studio/10 px-3 py-1 text-xs font-semibold text-brand-studio">{{ days }} days</span>
        }
    </div>

    <div>
        <div class="relative pt-6">
            <span class="absolute top-0 -translate-x-1/2 text-xs text-secondary"
                [style.left.%]="timeline().todayLeft">Today</span>
            <div class="relative mt-1 h-3" aria-hidden="true">
                <div class="absolute inset-x-0 top-1/2 h-1 -translate-y-1/2 rounded-full bg-border"></div>
                <div class="monitor-shade absolute inset-y-0 left-0" [style.width.%]="timeline().shade.width"></div>
                <div class="absolute inset-y-0 rounded-full bg-brand-studio"
                    [style.left.%]="timeline().range.left" [style.width.%]="timeline().range.width"></div>
                <span class="absolute -top-1 h-5 w-px bg-gray-900 dark:bg-white"
                    [style.left.%]="timeline().todayLeft"></span>
            </div>
        </div>
        <div class="mt-2 flex justify-between text-xs text-secondary">
            <span>{{ trackStartLabel() }}</span>
            <span>{{ trackEndLabel() }}</span>
        </div>
    </div>

    <div class="flex items-center justify-between gap-3">
        <p class="m-0 min-w-0 flex-1 text-sm text-secondary">{{ hint() }}</p>
        <button type="button" (click)="useRange()" [disabled]="!rangeReady()"
            class="btn-shout btn-shout-sm btn-shout-primary shrink-0">Use this range →</button>
    </div>
</div>
